import { getTextFromChars } from './block'
import { mdToBlockDocument, mdToBlocks } from './parser'
import { blocksToMd } from './serializer'
import {
  filterBlocks,
  findBlock,
  traverseBlocks,
  traverseBlocksDepthFirst,
} from './traverse'

export const blocks = {
  traverse: traverseBlocks,
  walk: traverseBlocks,
  walkDepthFirst: traverseBlocksDepthFirst,
  find: findBlock,
  filter: filterBlocks,
  serialize: blocksToMd,
  parse: mdToBlocks,
  parseDocument: mdToBlockDocument,
  text: getTextFromChars,
}

// Re-export types
export * from './block'
export * from './comments'
export * from './book-content'
export * from './book-segments'
export * from './parser'
export * from './serializer'
export * from './traverse'
export * from './types'
export * from './review-presentation'
export * from './block-viewer'

export { tableGrid } from './table-html'
export * from './translation-units'
export * from './speech-units'
